import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('Transport-index-1992f2b81938a6136-1'),
    routerUrl: '/transport',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./Info')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('Transport-index-1992f2b81938a6136-2'),
        routerUrl: '/InfoForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./InfoForm')),
      },
      //$MORE$
    ],
  },
];
